import { Injectable } from '@angular/core';
import { utils, writeFile } from 'xlsx';
import { saveAs } from 'file-saver';
import 'jspdf-autotable';
import jsPDF from 'jspdf';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  constructor(private date: DatePipe) {}

  /**
   * Export as excel
   */
  xlsx = (fileName: string, sheetName: string, data: Array<object>) => {
    const wb = utils.book_new();
    utils.book_append_sheet(wb, utils.json_to_sheet(data), sheetName);
    writeFile(wb, `${fileName}.xlsx`);
  };

  /**
   * Export as csv
   */
  csv = (fileName: string, data: Array<object>) => {
    saveAs(
      new Blob([utils.sheet_to_csv(utils.json_to_sheet(data))], {
        type: 'text/csv;charset=utf-8',
      }),
      `${fileName}.csv`
    );
  };

  /**
   * Export as pdf
   */
  pdf = (fileName: string, data: Array<object>) => {
    var doc = new jsPDF('l', 'cm', 'a4');
    let maxCol = data.find((a) => !!a);
    var col: any = [];
    for (let key in maxCol) {
      col.push(key);
    }
    var rows: any[][] = [];
    data.forEach((a: any) => {
      let temp: any = [];
      for (let key in a) {
        if (key.includes('Date')) {
          temp.push(this.getValidDate(a[key]));
        } else {
          temp.push(a[key] ? a[key] : '-');
        }
      }
      rows.push(temp);
    });
    (doc as any).autoTable(col, rows, {
      startY: 1,
    });
    doc.save(`${fileName}.pdf`);
  };

  getValidDate(value: string):any {
    if (value) {
      return value;
      // const date = this.date.transform(
      //   Number(value) * 1000,
      //   'MM/dd/yy, h:mm a z'
      // );
      // return (window as any).moment(date)
      //   .format('MM/DD/YYYY HH:mm:ss A zz');
    } else return '-';
  }
}
